import React from "react";
import App from "./App";
import { createRoot } from "react-dom/client";
import { FixedAttributionIcon } from "fixed-attribution-icon";
new FixedAttributionIcon(
  "https://github.com/Domenicobrz/R3F-in-practice/tree/main"
);
const root = createRoot(document.getElementById("root"));
root.render(<App />);
